module.exports = __webpack_public_path__ + "img/export.319a6e52.svg";